module.exports = __webpack_public_path__ + "img/visa-card.6c01e03f.jpg";